import React, { useMemo } from 'react';
import { TableTypes } from '../../enums/tableTypes';
import { TableUsersWinBets } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../store/gameStore';
import { BET_ACTION_MODAL_TYPE } from '../../enums/betActionModal';
import { Statistic } from '../statistics';
import { FavoriteBets } from '../favoriteBets';
import { ReBet } from '../autoBet';

const GameBottom = observer(({
  children,
  selectedData,
  mainTableType,
  handleMouseMove,
  handleMouseLeave,
  isShowBetActionModal,
  setIsShowBetActionModal,
}) => {
  const BetActionModal = useMemo(() => {
    const Components = {
      [BET_ACTION_MODAL_TYPE.statistics]: Statistic,
      [BET_ACTION_MODAL_TYPE.favoriteBets]: FavoriteBets,
      [BET_ACTION_MODAL_TYPE.reBet]: ReBet,
    };
    if (isShowBetActionModal) {
      return Components[isShowBetActionModal];
    }
    return null;
  }, [isShowBetActionModal]);

  return (
    <div className="roulette-game-bottom">
      <div
        className={`roulette-game-wrp ${gameStore.isBetsClosed ? 'round-on' : ''} ${
          mainTableType === TableTypes.Oval ? 'oval-table' : ''
        }`}
      >
        {children}
      </div>
      <TableUsersWinBets/>
      {BetActionModal && <BetActionModal selectedData={selectedData} handleMouseMove={handleMouseMove} handleMouseLeave={handleMouseLeave} setIsShowBetActionModal={setIsShowBetActionModal}/>}
    </div>
  );
});
export default GameBottom;
